export default __webpack_public_path__ + "static/image1-5f79e7887919ccd83bc45376bae9dbb3.png";